module.exports = __webpack_public_path__ + "static/media/29-2.3929b434.mp3";